namespace Matrix.Data {
    export interface ModelTargetRow {
        ModelCode?: string;
        TargetCode?: string;
        Level?: number;
        DefaultDisplayOrder?: number;
        SiblingDisplayOrder?: number;
        Code1?: string;
        Name1?: string;
        Code2?: string;
        Name2?: string;
        Code3?: string;
        Name3?: string;
        Code4?: string;
        Name4?: string;
        Code5?: string;
        Name5?: string;
        Code6?: string;
        Name6?: string;
        Code7?: string;
        Name7?: string;
        Code8?: string;
        Name8?: string;
        Code9?: string;
        Name9?: string;
        Code10?: string;
        Name10?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ModelTargetRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ModelCode';
        export const localTextPrefix = 'Data.ModelTarget';
        export const lookupKey = 'Data.ModelTarget';

        export function getLookup(): Q.Lookup<ModelTargetRow> {
            return Q.getLookup<ModelTargetRow>('Data.ModelTarget');
        }
        export const deletePermission = 'DataAdmin:ModelTarget';
        export const insertPermission = 'DataAdmin:ModelTarget';
        export const readPermission = 'Read:ModelTarget';
        export const updatePermission = 'DataAdmin:ModelTarget';

        export declare const enum Fields {
            ModelCode = "ModelCode",
            TargetCode = "TargetCode",
            Level = "Level",
            DefaultDisplayOrder = "DefaultDisplayOrder",
            SiblingDisplayOrder = "SiblingDisplayOrder",
            Code1 = "Code1",
            Name1 = "Name1",
            Code2 = "Code2",
            Name2 = "Name2",
            Code3 = "Code3",
            Name3 = "Name3",
            Code4 = "Code4",
            Name4 = "Name4",
            Code5 = "Code5",
            Name5 = "Name5",
            Code6 = "Code6",
            Name6 = "Name6",
            Code7 = "Code7",
            Name7 = "Name7",
            Code8 = "Code8",
            Name8 = "Name8",
            Code9 = "Code9",
            Name9 = "Name9",
            Code10 = "Code10",
            Name10 = "Name10",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
